import template from './placement-type.jade';
import validation from './../../../services/validation';
import options from '../../../enums/placement-type';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular.module('cian.addForm.placementType', []).directive('cianAfAboutObjectPlacementType', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService, store) {
    'ngInject';
    this.isMobile = deviceService.isMobile;
    this.items = options;

    this.validation = validation(this.form, 'placementType', {
      required: 'Укажите тип помещения',
    });

    this.handleChange = () => {
      const state = store.getState();
      const category = selectAnalyticsOfferStatus(state);

      trackRequiredFieldFill(category, 'building_type');
    };
  },
  controllerAs: 'placementType',
  template,
})).name;
